<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      persistent
      scrollable
      transition="dialog-top-transition"
      max-width="550px"
    >
      <v-card>
        <div class="container-comfirm">
          <div class="text-right">
            <v-icon class="cursor-pointer" @click="$emit('close')">mdi-close</v-icon>
          </div>
          <div class="card-title">
            <h3>ยังไม่ระบุร้านค้าช่วง</h3>
            <small>กรุณาเลือกร้านค้าช่วงเพื่อบันทึก Price & Stock</small>
          </div>

          <div class="card-search">
            <v-autocomplete
              item-text="customer_name"
              :items="customerItem"
              placeholder="เลือกร้าน"
              hide-details
              hide-selected
              solo
              return-object
              @change="selectedCustomer"
            />
          </div>
        </div>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  props: ['dialog', 'customerId', 'customerItem'],

  methods: {
    selectedCustomer(obj) {
      this.$emit('selected', obj)
    }
  }
}
</script>

<style lang="scss" scoped>
.container-comfirm {
  justify-content: center;
  margin: 30px 25px;
  display: flex;
  flex-direction: column;
  text-align: center;
}
.card-title {
  margin: 20px 0px;
}
.card-search {
  margin-bottom: 45px;
}

.v-card:not(.v-sheet--tile):not(.v-card--shaped) {
  border-radius: 20px !important;
}
</style>
